import { z } from 'zod'

import { AdUnitViewabilityTools } from 'features/inventory/ad-unit/types/AdUnitViewabilityTools'
import {
  lazyLoadingSchema,
  validateLazyLoadingSchema,
} from 'features/inventory/domain/forms/ViewabilityToolsForm/lazyLoadingSchema'

export const schema = z
  .object({
    adHoldingAutoEnabled: z.boolean(),
    adHoldingEnabled: z.boolean(),
    adUnitId: z.string(),
    customizeLazyLoadingParametersEnabled: z.boolean(),
    lazyLoadingAutoEnabled: z.boolean(),
    lazyLoadingEnabled: z.boolean(),
    scrollSlowingAutoEnabled: z.boolean(),
    scrollSlowingEnabled: z.boolean(),
    viewabilityToolsEnabled: z.boolean(),
  })
  .safeExtend(
    lazyLoadingSchema.pick({
      gamAdRequestMargin: true,
      kvTargetingAndPrebidAuction: true,
      lazyLoadTargetingPrebidAuctionEnabled: true,
      mobileScaling: true,
    }).shape,
  )
  .superRefine(validateLazyLoadingSchema)

export type Schema = z.infer<typeof schema>

export const schemaDefault = (
  data: Omit<AdUnitViewabilityTools, 'createdAt' | 'id' | 'updatedAt'>,
): Schema => ({
  ...data,
})
